import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './FormElement.module.scss.js';
import { FieldLabel } from './fieldLabel/FieldLabel.js';

var FormElement = function (_a) {
    var _b;
    var children = _a.children, required = _a.required, size = _a.size, htmlFor = _a.htmlFor, label = _a.label, hasError = _a.hasError, hasWarning = _a.hasWarning, disabled = _a.disabled, hintMessage = _a.hintMessage, hintMessageId = _a.hintMessageId, className = _a.className, hintMessageClassName = _a.hintMessageClassName, style = _a.style, labelId = _a.labelId, onLabelClick = _a.onLabelClick, showOptionalLabel = _a.showOptionalLabel;
    return (jsxs("div", __assign({ className: clsx(styles['form-element'], (_b = {
                formElementHasError: hasError,
                formElementHasWarning: hasWarning
            },
            _b[styles['has-error']] = hasError,
            _b[styles['has-warning']] = hasWarning,
            _b[styles['is-disabled']] = disabled,
            _b[styles['form-element_small']] = size === 's',
            _b), className), style: style }, { children: [label && (jsxs(FieldLabel, __assign({ className: styles['form-element__label'], htmlFor: htmlFor, size: size, required: required, id: labelId, onClick: onLabelClick }, { children: [label, " ", showOptionalLabel && jsx("span", __assign({ className: styles.optionalLabel }, { children: "Optional" }))] }))), children, hintMessage !== null && hintMessage !== undefined && (
            // disabled
            jsx("div", __assign({ className: clsx(styles['form-element__help'], hintMessageClassName), id: hintMessageId || '' }, { children: hintMessage })))] })));
};

export { FormElement };
